"use client";

import { useState } from "react";

import { CancelSubscriptionModal } from "@/app/(application)/(normal)/account/components/cancelSubscriptionLink/cancelSubscriptionModal/CancelSubscriptionModal";
import { LinkButton } from "@/components/links/LinkButton";
import { UserNoDates } from "@/types/types";

export function CancelSubscriptionLink({
  user,
  numberOfModels,
  numberOfMixedModels,
  subscriptionDurationInMonths,
}: {
  user: UserNoDates;
  numberOfModels: number;
  numberOfMixedModels: number;
  subscriptionDurationInMonths: number;
}) {
  const [cancelModalOpen, setCancelModalOpen] = useState(false);

  return (
    <>
      <CancelSubscriptionModal
        open={cancelModalOpen}
        closeModal={() => setCancelModalOpen(false)}
        user={user}
        numberOfModels={numberOfModels}
        numberOfMixedModels={numberOfMixedModels}
        subscriptionDurationInMonths={subscriptionDurationInMonths}
      />
      <LinkButton
        onClick={() => setCancelModalOpen(true)}
        className="text-gray-500"
      >
        Cancel subscription
      </LinkButton>
    </>
  );
}
